var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chartjs-component-polar-area-chart',{attrs:{"height":200,"data":_vm.data,"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }